import FilterInTable from '../../../../Manage/FilterInTable'
import styles from './Active.module.scss'
import { useEffect, useState } from 'react'
import PaginationComponent from '../../../../Manage/PaginationComponent'
import DatatableComponent from '../../../../../components/common/DatatableComponent/DatatableComponent'
import DynamicDropdown from '../../../../../components/common/SellerCommonComponents/DynamicDropdown/DynamicDropdown'
import InfoBadge from '../../../../../components/common/SellerCommonComponents/InfoBadge/InfoBadge'

const Active = () => {

  const [itemsPerPage, setItemsPerPage] = useState(3)
  const [currentPage, setCurrentPage] = useState(1)
  const [currentItems, setCurrentItems] = useState([])

  const data = [
    { name: 'First campaign', startDate: '20/06/2024', endDate: '-', lastUpdate: '23/06/2024', status: 'Active' },
    { name: 'First campaign', startDate: '20/06/2024', endDate: '-', lastUpdate: '23/06/2024', status: 'Active' },
    { name: 'First campaign', startDate: '20/06/2024', endDate: '-', lastUpdate: '23/06/2024', status: 'Active' },
    { name: 'First campaign', startDate: '20/06/2024', endDate: '-', lastUpdate: '23/06/2024', status: 'Active' },
    { name: 'First campaign', startDate: '20/06/2024', endDate: '-', lastUpdate: '23/06/2024', status: 'Active' },
    { name: 'First campaign', startDate: '20/06/2024', endDate: '-', lastUpdate: '23/06/2024', status: 'Active' },
    { name: 'First campaign', startDate: '20/06/2024', endDate: '-', lastUpdate: '23/06/2024', status: 'Active' },
    { name: 'First campaign', startDate: '20/06/2024', endDate: '-', lastUpdate: '23/06/2024', status: 'Active' },
    { name: 'First campaign', startDate: '20/06/2024', endDate: '-', lastUpdate: '23/06/2024', status: 'Active' },
    { name: 'First campaign', startDate: '20/06/2024', endDate: '-', lastUpdate: '23/06/2024', status: 'Active' },
    { name: 'First campaign', startDate: '20/06/2024', endDate: '-', lastUpdate: '23/06/2024', status: 'Active' },
  ]

  const columns = [
    {
      name: "Activate", cell: () => (
        <label className={styles.switch}>
          <input type="checkbox" />
          <span className={`${styles.slider} ${styles.round}`}></span>
        </label>
      )
    },
    {
      name: 'Campaign name',
      selector: row => row.name
    },
    {
      name: 'Start date',
      selector: row => row.startDate
    },
    {
      name: 'End date',
      selector: row => row.endDate
    },
    {
      name: 'Last Update',
      selector: row => row.lastUpdate
    },
    {
      name: 'Status',
      selector: row => {
        let color = ''
        switch (row.status) {
          case "Active":
            color = '#41B8E4'
            break;
          case "Deactivated":
            color = '#EC7426'
            break;
          case "Ended":
            color = '#EC7426'
            break;

          default:
            break;
        }
        return (<span style={{ color }}>{row.status}</span>)
      }
    },
    {
      name: "Action",
      cell: () => (<span className='cursor-pointer'>Edit/Delete</span>)
    }
  ]

  const handlePageChange = (page) => {
    setCurrentPage(page)
    const startIndex = (page - 1) * itemsPerPage
    const endIndex = startIndex + itemsPerPage
    setCurrentItems(data.slice(startIndex, endIndex))
  }

  const handleRowsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage)
    setCurrentPage(1)
    handlePageChange(1)
  }

  useEffect(() => {
    handlePageChange(currentPage)
  }, [currentPage, itemsPerPage])

  const printDropdownOptions = [
    { label: "Print invoices of selected items", action: () => console.log("print group") },
    { label: "Print shipping labels for selected items", action: () => console.log("print group") },
    { label: "Print stock checklist for selected items", action: () => console.log("print group") },
  ]

  const exportDropdownOptions = [
    { label: "Export all orders", action: () => console.log("export group") },
    { label: "Export all selected orders", action: () => console.log("export group") },
    { label: "Export all pending orders", action: () => console.log("export group") },
    { label: "Export all ready to ship orders", action: () => console.log("export group") },
    { label: "Export all shipped orders", action: () => console.log("export group") },
    { label: "Export all delivered orders", action: () => console.log("export group") },
    { label: "Export all cancelled orders", action: () => console.log("export group") },
    { label: "Export all returned orders", action: () => console.log("export group") },
    { label: "Export all refund only orders", action: () => console.log("export group") },
    { label: "Export all failed delivery orders", action: () => console.log("export group") },
  ]

  const viewHistoryOptions = [
    { label: "Today", action: () => console.log("Viewing history for Today") },
    { label: "Yesterday", action: () => console.log("Viewing history for Yesterday") },
    { label: "Last 7 days", action: () => console.log("Viewing history for Last 7 days") },
    { label: "Last month", action: () => console.log("Viewing history for Last month") },
  ]

  

  return (
    <section>

      <div className='d-flex justify-content-between mb-2'>
        <InfoBadge>Total Campaign: 30</InfoBadge>

        <div className='d-flex gap-2'>
        <DynamicDropdown placeholder="Print" options={printDropdownOptions} />
          <DynamicDropdown placeholder="Export" options={exportDropdownOptions} />
          <DynamicDropdown placeholder="View History" options={viewHistoryOptions} />
        </div>
      </div>
      
      <div className='mb-3'>
        <FilterInTable componentName='Advertisement Management' />
      </div>

      <DatatableComponent data={currentItems} columns={columns} type='gray' />

      <PaginationComponent
        totalItems={data.length}
        siblingCount={2}
        itemsPerPage={itemsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
    </section>
  )
}

export default Active